import { Component, input, viewChildren } from '@angular/core';
import type { JssNavItem } from '@core/jss-models';
import { NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NavLinkComponent } from '@core/navigation-ui/nav-link';
import { TrackLinkDirective } from '@analytics/events';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'wl-navigation-desktop',
  standalone: true,
  imports: [
    NgbDropdownModule,
    FaIconComponent,
    NavLinkComponent,
    TrackLinkDirective,
    AutomationIdDirective,
  ],
  templateUrl: './navigation-desktop.component.html',
  styleUrls: [
    './navigation-desktop.component.ed.scss',
    './navigation-desktop.component.essent.scss',
  ],
})
export class NavigationDesktopComponent {
  readonly navigationItems = input<JssNavItem[]>([]);

  readonly navigationDropdownEl = viewChildren(NgbDropdown);

  /**
   * On navigation, close any open dropdown menu's
   */
  navigationEffects() {
    this.navigationDropdownEl().forEach((dropdownEl) => dropdownEl.close());
  }
}
